import React from 'react';
import MathCCA2023 from 'views/MathCCA2023';

const MathClubPage = () => {
  return <MathCCA2023/>;
};

export default MathClubPage;

